import { FlexiToggle } from "appworks/graphics/elements/flexi-toggle";
import { Model } from "appworks/model/model";
import { ToggleControl } from "appworks/ui/controls/standard/toggle/toggle-control";

export class GamevyDontShowControl extends ToggleControl {
    constructor(button: FlexiToggle) {
        super(button);

        Model.onUpdate.add(this.onSettingsUpdate);
        this.onSettingsUpdate();
    }

    public destroy(): void {
        Model.onUpdate.remove(this.onSettingsUpdate);
    }

    protected onChange(showIntro: boolean): void {
        super.onChange(showIntro);
        Model.write({ settings: { showIntro } });
    }

    protected onSettingsUpdate = () => {
        const { showIntro } = Model.read().settings;
        this.button.setValue(!showIntro);
    }
}
